import useHeaderStore, { toggleMobileMenu } from 'layout/header/store';
import { hamburgerLineStyle } from 'layout/header/styles';

import type { FC } from 'react';

const Hamburger: FC = () => {
  const open = useHeaderStore(state => state.mobileMenuOpen);

  return (
    <button
      tabIndex={0}
      onClick={toggleMobileMenu}
      className="group relative flex h-3 w-4 cursor-pointer xl:hidden"
      aria-expanded={open}
      aria-label="Toggle mobile menu"
    >
      {Array(3)
        .fill(null)
        .map((_, index) => (
          <span key={`line-${index + 1}`} className={hamburgerLineStyle({ line: index as 0 | 1 | 2 })} />
        ))}
    </button>
  );
};

export default Hamburger;
